<template>
  <div class="login-main">
    <div class="login-container">
      <SettingButton></SettingButton>
      <div class="login-content">
        <label class="login-label">
          账号：
          <input class="login-input" type="text" placeholder="请输入账号" v-model='inputUserName'/>
        </label>
        <label class="login-label">
          密码：
          <input class="login-input" type="password" placeholder="请输入密码" v-model='inputPassword'/>
        </label>
      </div>
      <div>
        <button class="login-btn" @click="loginProcess">
          登 录
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import SettingButton from "@/components/SettingButton";

export default {
  name: 'loginPage',
  components: {
    SettingButton
  },
  data() {
    return {
      inputUserName: "",
      inputPassword: ""
    };
  },
  methods: {
    loginProcess: function (e) {
      let that = this;
      console.log(e);

      this.$router.push({
        path: '/mainPage',
        // query:{
        //   id:this.id ,
        // }
      })

      this.axios.post("/login", {
        username: this.inputUserName,
        password: this.inputPassword
      }).then(res => {
        if (res && res.status === 200) {
          console.log(res);
          that.$router.push({
            path: '/mainPage',
            // query:{
            //   id:this.id ,
            // }
          })
        }
      }).catch(error => {
        // console.error(error);
        if (error.response) {
          // console.error(error.response);
        }
      })
    }
  },
  mounted() {
  },
  destroyed() {
  }
}
</script>

<style scoped>
.login-main {
  width: 100vw;
  height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url("../assets/image/loginPage/LoginBg.png");
}

.login-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-content: center;
  height: 5rem;
}

.login-container {
  width: 100%;
  display: flex;
  bottom: 15%;
  position: fixed;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: 10rem;
}

.login-label {
  color: white;
  font-family: "PingFang", serif;
  font-size: 18px;
  height: 2rem;
}

.login-input {
  width: 35%;
  height: 1.5rem;
}

.login-btn {
  width: 7rem;
  height: 2.5rem;
  font-size: 22px;
  background-image: url("../assets/image/loginPage/LoginBtn.png");
  background-size: 100% 100%;
  border: none;
  color: white;
  font-family: "PingFang", serif;
  background-color: transparent;
}

.login-btn:active {
  transform: translateY(2px);
  background-color: transparent;
}
</style>
